//#region src/adapter/webEventSourceAdapter.ts
var e = { open(e, { withCredentials: t, onOpen: n, onError: r }) {
	let i = new EventSource(e, { withCredentials: t });
	return n && (i.onopen = () => n()), r && (i.onerror = (e) => r(e)), {
		addEventListener(e, t) {
			i.addEventListener(e, (e) => t(e.data));
		},
		close() {
			i.close();
		}
	};
} };
//#endregion
export { e as webEventSourceAdapter };
